import React from 'react'
import { withStyles, Drawer, Hidden } from '@material-ui/core';
import SideNavigationsMenu from '../DashboardLayout/SideNavigations/SideNavigationsMenu';
import { withRouter } from 'react-router-dom';

const styles = (theme) => ({
    drawer: { background: '#1b5e20', width: 70, borderRight: 'none', marginTop: 70, },
    drawerClasszindex: { zIndex: '1400 !important' },

});

const Sidebar = (props) => {
    const { classes } = props;
    return (
        <React.Fragment>
            <Hidden only='xs'>
                <Drawer
                    classes={{ paperAnchorLeft: classes.drawer, paper: classes.drawerClasszindex }}
                    variant="permanent"
                >
                    <SideNavigationsMenu
                        pageUri={props.location.pathname}
                    />
                </Drawer>
            </Hidden>
        </React.Fragment>
    );
}

export default withStyles(styles)(withRouter(Sidebar));
